export default __webpack_public_path__ + "static/media/img_tree.97c68af2.png";